var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 31.179,
    viewBox: "0 0 58 31.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 58,
    height: 31.179,
    fill: "#f56105"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M55.128,11.092a22.883,22.883,0,0,0-5.119-.027q.764.925,1.548,1.829a76.433,76.433,0,0,0-7.982,4.779A99.511,99.511,0,0,1,33.9,4.683Q32.454,2.378,31.138,0,30.094.063,29,.063T26.862,0Q25.547,2.377,24.1,4.683a99.511,99.511,0,0,1-9.679,12.991,76.433,76.433,0,0,0-7.982-4.779q.784-.9,1.548-1.829a22.877,22.877,0,0,0-5.118.027q-.454.509-.914,1.01L0,14.238l2.53,1.195a72.576,72.576,0,0,1,11.157,6.559l1.252.894L16,21.725A103.44,103.44,0,0,0,28.245,5.211q.383-.639.756-1.283.372.644.755,1.283A103.484,103.484,0,0,0,42,21.725l1.058,1.161,1.253-.894A72.576,72.576,0,0,1,55.47,15.432L58,14.238,56.042,12.1q-.46-.5-.914-1.01",
    transform: "translate(0 0)",
    fill: "#f56105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M31.309,23.088c3.728,6.788,6,9.879,6.209,13.522.212-3.643,2.481-6.734,6.209-13.522q-1.309-1.507-2.508-3.124a26.327,26.327,0,0,0-3.7,8.339,26.342,26.342,0,0,0-3.7-8.339q-1.2,1.615-2.509,3.124",
    transform: "translate(-8.518 -5.431)",
    fill: "#f56105"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadericon);
export default __webpack_public_path__ + "static/media/headericon.d5d6f23ab5562324811126bd1d718e49.svg";
export { ForwardRef as ReactComponent };